/* eslint-disable */
// COPY of music-games projects/practice-player/core.js (commit 4849e71), the practice
// player's timeline and transport, shared with the bells page. Do not edit here:
// change it in music-games and copy it again with app/bells/sync-core.sh.
/* Pure score/timeline functions. Beats of the piece's own count (quarter notes
   in 4/4, eighth notes in 3/8), not wall-clock time.
   Handles printed repeats, tied notes, selected passages, and counted gaps.
   The browser and headless tests use this same module. */
(function (root) {
  'use strict';
  const EPS = 1e-7;
  // Every printed measure, in the order it is printed: where it begins in
  // printed time, how many beats it holds, the words it is called by, and where
  // in a full bar its first beat falls (a pickup sits at the end of its bar).
  // A measure is known by its place in this list, counted from 1, because a
  // first and a second ending can carry the same printed number. A piece
  // written before measures were listed has full bars only, numbered from 1.
  function measures(piece) {
    if(!piece._measures) piece._measures = piece.measures
      ? piece.measures.map(m=>({offset:0,...m}))
      : Array.from({length:piece.measureCount},(_,i)=>({label:String(i+1),start:i*piece.beatsPerBar,length:piece.beatsPerBar,offset:0}));
    return piece._measures;
  }
  function makePlan(piece, options = {}) {
    const b = piece.beatsPerBar, M = measures(piece);
    const range = options.range;
    const order = range
      ? Array.from({length: range.end - range.start + 1}, (_,i) => range.start+i)
      : options.repeats === false
        ? Array.from({length:piece.measureCount},(_,i)=>i+1) : piece.order.slice();
    if (!order.length || order.some(n=>!Number.isInteger(n)||n<1||n>piece.measureCount)) throw Error('Invalid measure range');
    let beats = 0;
    const spans = order.map(measure=>{
      const m=M[measure-1], span={measure, beat:beats, sourceBeat:m.start, duration:m.length, offset:m.offset};
      beats+=m.length; return span;
    });
    // Keep ties across consecutive printed measures. Only a jump or passage
    // boundary ends a segment; starting inside a held note sounds its remainder.
    const segments = [];
    for (const span of spans) {
      const last=segments[segments.length-1];
      if(last && Math.abs(last.sourceEnd-span.sourceBeat)<EPS) last.sourceEnd+=span.duration;
      else segments.push({beat:span.beat,sourceStart:span.sourceBeat,sourceEnd:span.sourceBeat+span.duration});
    }
    const notes=[];
    for(const seg of segments) for(const part of piece.parts) for(const n of part.notes) {
      const start=Math.max(seg.sourceStart,n.beat), end=Math.min(seg.sourceEnd,n.beat+n.duration);
      if(end-start>EPS) notes.push({...n, part:part.id, sourceBeat:start,
        beat:seg.beat+start-seg.sourceStart,duration:end-start});
    }
    notes.sort((a,b)=>a.beat-b.beat||a.midi-b.midi);
    // lead: the place in the bar where the music begins (2 for a pickup of one
    // beat in three). tail: the place in the bar where it stops. The count-in
    // and the counted bars between repeats are lengthened by these, so that the
    // strong click always falls on a downbeat.
    const lead=spans[0].offset, tail=(lead+beats)%b;
    return {spans,notes,beats,beatsPerBar:b,order,lead,tail};
  }
  // A call-and-response section: a few beats of the piece, then a rest, as one
  // cycle with its own meter, however the measures are printed (Jack,
  // 2026-10-12: "you're going to have to be able to think outside of
  // measures"). from/to bound the music in printed beats; a note sounds if
  // its attack lies in [from, to), for its full written length. cycle is the
  // length of one time round, group how its beats are numbered (1..group).
  // The page plays the first pass; from the second on only the click sounds
  // and the student plays. The count shows from the start of the group that
  // holds the last attack to the end of the cycle, so it reads 1 2 3 4 over
  // the rest. hands names one part, or 'both'.
  // start is where the cycle's own beat 1 falls, in the same beats: by
  // default the first whole beat at or after from, so a pickup of a
  // sixteenth or two before it is played during the count (Für Elise's
  // B-C-D before measure 9 falls on the "and" of 4). The last note is "1"
  // of the count and 2 3 4 follow, so cycle defaults to that note plus one
  // group. unfold takes the piece as played, repeats and endings in order,
  // so the whole piece can be one section.
  // and: when the music starts off the beat (a pickup), the count is said
  // "1 and 2 and 3 and 4 and", so the student comes in on the last "and"
  // (Jack, 2026-10-12: "we need to hear the count as 1 and 2 and 3 and four
  // and"). It is the cycle beat of the "and" the music starts in, negative
  // since it falls before beat 1; null when the music starts on a beat or
  // the section says and:false.
  // turn: the student's own choices for a part (Jack, 2026-11-02: "it
  // should be an option for students to choose their countin and also to
  // have the piano playing with them or not"). hear:false leaves out the
  // first pass that is played to them, so the first pass is theirs;
  // countBars is how many groups the count-in lasts (1 or 2); along:true
  // sounds the part's notes on their turns too ("the piano part plays
  // while she plays. whatever part she's on"). With none given, a part
  // plays once, counts one group in, and is silent on their turns.
  function makeCyclePlan(piece, section, hands='both', turn={}) {
    const hear=turn.hear!==false, along=!!turn.along, countBars=turn.countBars===2?2:1;
    const from=section.from, to=section.to, group=section.group||4;
    // Optional per-slot labels keep a compound-meter reset in the piece's feel.
    // Slots remain 1..group for the clock and highlighting; only spoken labels change.
    const countPattern=section.countPattern;
    if(countPattern&&(!Array.isArray(countPattern)||countPattern.length!==group||countPattern.some(n=>!Number.isInteger(n)||n<1||n>4))) throw Error('Invalid count pattern');
    let source, spans0;
    if(section.unfold) {
      const P=makePlan(piece,{repeats:true});
      source=P.notes.map(n=>({...n})); spans0=P.spans.map(s=>({...s}));
    } else {
      source=piece.parts.flatMap(part=>part.notes.map(n=>({...n,part:part.id,sourceBeat:n.beat})));
      spans0=measures(piece).map((m,i)=>({measure:i+1,beat:m.start,sourceBeat:m.start,duration:m.length,offset:m.offset}));
    }
    const picked=source.filter(n=>(hands==='both'||n.part===hands)&&n.beat>=from-EPS&&n.beat<to-EPS);
    const all=source.filter(n=>n.beat>=from-EPS&&n.beat<to-EPS);
    if(!(to>from)||!all.length) throw Error('Invalid section');
    const start=section.start!==undefined?section.start:Math.ceil(from-EPS)||0;
    const last=Math.max(...all.map(n=>n.beat));
    const countFrom=section.countFrom!==undefined?section.countFrom-start:last-start;
    const cycle=section.cycle!==undefined?section.cycle:countFrom+group;
    if(!(cycle>=to-start-EPS)&&!(cycle>last-start)) throw Error('Invalid section');
    const notes=picked.map(n=>({...n,beat:n.beat-start,duration:Math.min(n.duration,cycle-(n.beat-start))}))
      .sort((a,b)=>a.beat-b.beat||a.midi-b.midi);
    const spans=spans0.filter(s=>s.beat+s.duration>from+EPS&&s.beat<to-EPS)
      .map(s=>({measure:s.measure,beat:s.beat-start,sourceBeat:s.sourceBeat,duration:s.duration,offset:s.offset}));
    const spanOf=local=>{let i=spans.length-1;while(i>0&&spans[i].beat>local+EPS)i--;return spans[i];};
    // The printed beat at a beat of the cycle, for the cursor on the score.
    const srcOf=local=>{const s=spanOf(local);return s.sourceBeat+Math.min(s.duration-EPS,Math.max(0,local-s.beat));};
    const entry=from-start, offBeat=Math.abs(entry-Math.round(entry))>EPS;
    const and=section.and!==false&&offBeat&&entry<0?Math.floor(entry+EPS)+0.5:null;
    return {kind:'cycle',spans,notes,beats:cycle,group,countFrom,start,from,to,and,countPattern,
      musicFrom:from-start,music:to-start,soundPasses:hear?[1]:[],firstTurn:hear?2:1,along,countBars,beatsPerBar:group,order:spans.map(s=>s.measure),
      lead:0,tail:0,srcOf,measureAt:local=>spanOf(local).measure,unfold:!!section.unfold};
  }
  // Where the music stops, in beats: a cycle plan runs until stopped unless a
  // number of passes is asked for (two for a recording: the hearing and the
  // turn); a measure plan ends after one pass unless it loops.
  function endOf(plan,config={}) {
    if(plan.kind==='cycle') return config.passes?config.passes*plan.beats:Infinity;
    return config.loop?Infinity:plan.beats;
  }
  function cyclePosition(plan,q,config={}) {
    const g=plan.group, cycle=plan.beats;
    const num=local=>((Math.floor(local+EPS)%g)+g)%g+1;
    const first=Math.max(0,plan.musicFrom);
    // The second half of a counted beat, when the count says "and".
    const half=x=>plan.and!=null&&x-Math.floor(x+EPS)>=0.5-EPS;
    if(q<0) return {phase:'count-in',measure:plan.measureAt(first),sourceBeat:plan.srcOf(first),beat:num(q),count:num(q),
      and:half(q),barsLeft:Math.ceil(-q/g),pass:1,local:0,turn:'hear'};
    if(q>=endOf(plan,config)) return {phase:'ended',measure:plan.order.at(-1),sourceBeat:plan.srcOf(plan.music-EPS),
      beat:g,count:null,pass:config.passes,local:cycle,turn:'play'};
    const pass=Math.floor(q/cycle+EPS)+1, local=q-(pass-1)*cycle;
    const playing=local<plan.music-EPS, at=Math.min(local,plan.music-EPS);
    return {phase:playing?'playing':'gap',measure:plan.measureAt(at),sourceBeat:plan.srcOf(at),beat:num(local),
      count:local>=plan.countFrom-EPS?num(local-plan.countFrom):null,
      and:local>=plan.countFrom-EPS&&half(local)&&!(config.passes&&pass>=config.passes&&local>=cycle-0.5-EPS),barsLeft:Math.ceil((cycle-local)/g),
      pass,local,turn:plan.soundPasses.includes(pass)?'hear':'play'};
  }
  const countIn=(plan,config)=>plan.kind==='cycle'?plan.group*(plan.countBars||1):config.countInBars*plan.beatsPerBar+plan.lead;
  function gapBeats(plan,config) {
    const b=plan.beatsPerBar;
    return config.loop ? config.gapBars*b+(((plan.lead-plan.tail)%b)+b)%b : 0;
  }
  function spanAt(plan,local) {
    let low=0, high=plan.spans.length-1;
    while(low<high){ const mid=(low+high+1)>>1; if(plan.spans[mid].beat<=local+EPS) low=mid; else high=mid-1; }
    return low;
  }
  function position(plan,q,config={}) {
    if(plan.kind==='cycle') return cyclePosition(plan,q,config);
    const b=plan.beatsPerBar, gap=gapBeats(plan,config);
    const period=plan.beats+gap;
    if(q<0) return {phase:'count-in',measure:plan.order[0],sourceBeat:plan.spans[0].sourceBeat,
      beat:(((Math.floor(q)+plan.lead)%b)+b)%b+1,barsLeft:Math.ceil(-q/b),pass:1,local:0};
    const final=plan.spans.at(-1);
    if(!config.loop && q>=plan.beats) return {phase:'ended',measure:plan.order.at(-1),
      sourceBeat:final.sourceBeat+final.duration-EPS,beat:b,pass:1,local:plan.beats};
    const pass=config.loop ? Math.floor(q/period) : 0;
    const local=q-pass*period;
    if(local>=plan.beats) return {phase:'gap',measure:plan.order[0],sourceBeat:plan.spans[0].sourceBeat,
      beat:Math.floor(plan.tail+local-plan.beats)%b+1,barsLeft:Math.ceil((period-local)/b),pass:pass+1,local};
    const index=spanAt(plan,local), span=plan.spans[index];
    return {phase:'playing',measure:span.measure,sourceBeat:span.sourceBeat+local-span.beat,
      beat:Math.floor(span.offset+local-span.beat)%b+1,pass:pass+1,occurrence:index,local};
  }
  function eventsBetween(plan,from,to,config={}) {
    if(!(to>from)) return [];
    if(plan.kind==='cycle') {
      // Notes only in the passes that are the page's to play; a click on
      // every beat, all alike, through the count-in, the music and the rest.
      const period=plan.beats, stop=Math.min(to,endOf(plan,config)), events=[];
      // A pickup belongs to its pass but sounds just before it starts, so
      // the next pass is looked at too.
      const first=Math.max(0,Math.floor(Math.max(0,from)/period)), last=Math.max(0,Math.floor((stop-EPS)/period))+1;
      for(let pass=first;pass<=last;pass++) {
        if(!plan.along&&!plan.soundPasses.includes(pass+1)) continue;
        for(const n of plan.notes) { const beat=pass*period+n.beat; if(beat>=from-EPS&&beat<stop-EPS) events.push({...n,beat,kind:'note',pass:pass+1}); }
      }
      for(let q=Math.ceil(from-EPS);q<stop-EPS;q++) { const p=position(plan,q,config); const counted=p.count==null?null:(plan.countPattern?.[p.count-1]??p.count);
        const tier=plan.countPattern?(plan.countPattern[p.beat-1]===1?3:2):2;
        // entry: the last number before the music comes in, which Settings
        // can keep spoken when the count is too fast to say every number.
        const entry=counted!=null&&plan.and==null&&q+1<endOf(plan,config)-EPS&&position(plan,q+1,config).count==null;
        events.push({kind:'click',beat:q||0,tier,phase:p.phase,count:counted,entry}); }
      // "and" after every counted beat, the count-in's included, but not the
      // last one of a recording, which would lead into nothing.
      if(plan.and!=null) for(let q=Math.ceil(from-0.5-EPS);q<stop-0.5-EPS;q++) {
        const beat=q+0.5;if(beat<from-EPS||beat>=endOf(plan,config)-0.5-EPS)continue;
        // entry: the "and" the music starts in, the last before each pass.
        const entry=Math.abs(((beat-plan.and)%plan.beats+plan.beats)%plan.beats)<EPS;
        if(position(plan,q,config).count!=null) events.push({kind:'click',beat,tier:1,phase:'count',count:'and',entry});
      }
      return events.sort((a,b)=>a.beat-b.beat);
    }
    const period=plan.beats+gapBeats(plan,config), events=[];
    const first=Math.max(0,Math.floor(Math.max(0,from)/period));
    const last=config.loop ? Math.max(0,Math.floor(to/period)) : 0;
    for(let pass=first;pass<=last;pass++) for(const n of plan.notes) {
      const beat=pass*period+n.beat;
      if(beat>=from-EPS && beat<to-EPS) events.push({...n,beat,kind:'note',pass:pass+1});
    }
    // The bar just before the student plays, the count-in's and each gap's,
    // is counted aloud, 1 2 3 4, as on a call part (Jack, 2026-10-15: "it
    // should count in not just on record but always when the student is
    // about to play"). Before a pickup that is a full bar and the beats up to
    // it ("1 2 3, 1 2" and in on 3). Earlier bars only click.
    const gapLen=gapBeats(plan,config);
    for(let q=Math.ceil(from-EPS);q<to-EPS;q++) {
      const p=position(plan,q,config);
      if(p.phase==='count-in'||p.phase==='gap'||(p.phase==='playing'&&config.clickDuring)) {
        const left=p.phase==='count-in'?-q:p.phase==='gap'?plan.beats+gapLen-p.local:Infinity;
        const lead=left<=plan.beatsPerBar+plan.lead+EPS;
        const entry=lead&&position(plan,q+1,config).phase==='playing';
        events.push({kind:'click',beat:q,tier:p.beat===1?3:2,phase:p.phase,count:lead?p.beat:null,entry});
      }
    }
    return events.sort((a,b)=>a.beat-b.beat);
  }
  function heldAt(plan,q,config={}) {
    const p=position(plan,q,config);
    if(p.phase!=='playing'||(p.turn==='play'&&!plan.along)) return [];
    return plan.notes.filter(n=>n.beat<p.local-EPS && n.beat+n.duration>p.local+EPS)
      .map(n=>({...n,kind:'note',beat:q,duration:n.beat+n.duration-p.local}));
  }
  class Transport {
    constructor(audio,onState=()=>{}) { this.audio=audio;this.onState=onState;this.running=false;this.q=0;this.timer=null;this.serial=0; }
    configure(plan,config) { this.plan=plan;this.config={...config}; }
    current() { return this.running ? this.anchorQ+Math.max(0,this.audio.context.currentTime-this.anchorTime)/this.spb : this.q; }
    play(q=this.q) {
      this.halt(false);this.q=q;this.spb=60/this.config.tempo;
      this.anchorQ=q;this.anchorTime=this.audio.context.currentTime+(this.audio.lead?this.audio.lead():0.06);
      this.scheduled=q;this.running=true;this.serial++;this.audio.begin();
      for(const n of heldAt(this.plan,q,this.config)) this.send(n);
      this.topUp(this.serial);this.onState('playing');
    }
    send(e) {
      const at=this.anchorTime+(e.beat-this.anchorQ)*this.spb;
      if(at<this.audio.context.currentTime-0.015) return;
      if(e.kind==='click') this.audio.click(at,e.tier,e.count,this.spb,e.entry);
      else this.audio.note(e.part,e.midi,at,e.duration*this.spb,e.velocity);
    }
    topUp(serial) {
      if(!this.running||serial!==this.serial) return;
      const q=this.current();
      const end=endOf(this.plan,this.config);
      if(q>=end) { this.q=end;this.halt(false);this.onState('ended');return; }
      // Four whole bars ahead; replenish once per bar, never from animation.
      const horizon=Math.ceil((q+16)/4)*4;
      const from=Math.max(this.scheduled,q);
      for(const e of eventsBetween(this.plan,from,horizon,this.config)) this.send(e);
      this.scheduled=horizon;
      let wait=4*this.spb;
      if(end<Infinity) wait=Math.min(wait,Math.max(0.02,(end-q)*this.spb));
      this.timer=setTimeout(()=>this.topUp(serial),wait*1000);
    }
    halt(remember=true) {
      if(remember&&this.running) this.q=this.current();
      this.running=false;this.serial++;clearTimeout(this.timer);this.timer=null;
      this.audio.silence();
    }
    pause() { this.halt();this.onState('paused'); }
    stop(q=0) { this.halt(false);this.q=q;this.onState('stopped'); }
    retime(tempo) { const q=this.current();this.config.tempo=tempo;if(this.running)this.play(q); }
    // Where the music is for the ear: the scheduled place, less the time the
    // sound takes to come out. What is shown follows this; what is scheduled
    // follows current().
    // The beat at a moment on the audio clock: where a note played by hand
    // falls on the click, worked out as the note arrives.
    beatAt(t) { return this.running ? this.anchorQ+(t-this.anchorTime)/this.spb : null; }
    heard() {
      if(!this.running) return this.q;
      const late=(this.audio.latency?this.audio.latency():0)/this.spb;
      return Math.max(this.anchorQ,this.current()-late);
    }
    state() { return position(this.plan,this.heard(),this.config); }
  }
  const api={measures,makePlan,makeCyclePlan,endOf,countIn,position,eventsBetween,heldAt,Transport};
  if(typeof module!=='undefined'&&module.exports) module.exports=api;
  else root.PracticeCore=api;
})(typeof window!=='undefined'?window:globalThis);
